export default function ({ children }) {
    return (
        <ul className="flex">
            {children}
        </ul>
    )
}
